import React, { Component } from 'react';
import cx from 'classnames';

import { theme } from './theme.js';

class SlatePaneBar extends Component {
  render() {
    const { onDock, onHide, onPrev, onNext, isDocked } = this.props;

    return (
      <div className="slate-pane-bar" style={theme.slatePaneHeader}>
        <div className="slate-pane-bar-actions">
          <div className="slate-pane-icon slate-pane-pin" onClick={onDock}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" style={{ transform: 'scaleX(-1)', verticalAlign: 'middle' }}>
              {isDocked ? (
                <>
                  <path d="M18 3H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h12c1.1 0 2-.89 2-2V5c0-1.1-.9-2-2-2zm0 16H6V5h12v14z"/>
                  <path d="M14 7l-5 5 5 5V7z"/>
                </>
              ) : (
                <>
                  <path d="M18 3H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H6V5h12v14z"/>
                  <path d="M10 17l5-5-5-5v10z"/>
                </>
              )}
            </svg>
          </div>
          <div className="slate-pane-icon slate-pane-close" onClick={onHide}>
            <i className="material-symbols-outlined slate-pane-bar-icon slate-pane-bar-icon-close">close</i>
          </div>
        </div>
        <div className="slate-pane-bar-actions-right">
          {(onPrev || onNext) && (
            <React.Fragment>
              <div
                className={cx('slate-pane-icon', 'slate-pane-next', {
                  'slate-pane-icon-disabled': !onPrev,
                })}
                onClick={onPrev}
              >
                <i className="material-symbols-outlined slate-pane-bar-icon">chevron_left</i>
              </div>
              <div
                className={cx('slate-pane-icon', 'slate-pane-next', {
                  'slate-pane-icon-disabled': !onNext,
                })}
                onClick={onNext}
              >
                <i className="material-symbols-outlined slate-pane-bar-icon">chevron_right</i>
              </div>
            </React.Fragment>
          )}
          <div
            className="slate-pane-icon slate-pane-close-btn"
            onClick={onHide}
          >
            <i className="material-symbols-outlined slate-pane-bar-icon slate-pane-bar-icon-close">close</i>
          </div>
        </div>
      </div>
    );
  }
}

export default SlatePaneBar;
